import React, { useState } from 'react';
import { Box } from '@bpba/ui-components';
import { BsInfoCircleFill } from 'react-icons/bs';
import styled from 'styled-components';

export type TooltipProps = {
  message?: string;
};

type ToolTipContainerProps = React.PropsWithChildren<{
  hidden: boolean;
}>;

export function Tooltip(props: TooltipProps) {
  const [showToolTip, setShowToolTip] = useState(true);

  const toggleTooltip = () => {
    setShowToolTip((toggle) => !toggle);
    setTimeout(() => setShowToolTip(true), 3000);
  };

  return (
    <>
      <Box width="10% !important">
        <BsInfoCircleFill onClick={toggleTooltip} />
      </Box>

      <ToolTipContainer hidden={showToolTip}>{props.message}</ToolTipContainer>
    </>
  );
}

const ToolTipContainer = styled.div<ToolTipContainerProps>(({ hidden }) => ({
  display: hidden ? 'none' : 'block',
  color: 'white',
  backgroundColor: 'black',
  position: 'absolute',
  padding: '5px 15px',
  fontSize: '12px',
  borderRadius: '4px',
  right: '30px',
  zIndex: 2,
}));
